export default {
	isAuth: state => (state.token ? true : false)
};
